import SectionHeading from "@/components/base/SectionHeading";
import Tag from "@/components/base/Tag";
import Reveal from "@/components/base/Reveal";
import { timelineItems } from "@/mocks/homeData";

export default function EventTimeline() {
  return (
    <section id="timeline" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <SectionHeading
          eyebrow="事件时间线"
          eyebrowIcon="ri-time-line"
          title="按日期倒着排，谁先谁后一目了然"
          desc="同一件事往往有好几个说法，时间线只记录「什么时候发生了什么」，方便自己判断。"
        />

        <div className="grid gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-8">
            <div className="relative border-l border-background-300 pl-6 md:pl-8">
              {timelineItems.map((item, index) => (
                <Reveal key={item.id} delay={index * 60}>
                  <article className="relative pb-8 last:pb-0">
                    <span className="absolute -left-[31px] top-1 flex h-3 w-3 items-center justify-center rounded-full border-2 border-background-100 bg-primary-500 md:-left-[39px]"></span>
                    <div className="flex flex-wrap items-center gap-3">
                      <span className="font-mono text-xs text-secondary-600">{item.date}</span>
                      <Tag variant="secondary">{item.tag}</Tag>
                    </div>
                    <h3 className="mt-2 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                  </article>
                </Reveal>
              ))}
            </div>
          </div>

          <div className="lg:col-span-4">
            <div className="sticky top-24 rounded-lg border border-background-200 bg-background-50 p-5">
              <h3 className="font-heading text-base font-bold text-foreground-950">这条线怎么读</h3>
              <ul className="mt-4 space-y-4">
                {[
                  { icon: "ri-record-circle-line", text: "圆点是事件被公开讨论的起始时间。" },
                  { icon: "ri-links-line", text: "同一天多条记录会合并到同一节点下。" },
                  { icon: "ri-refresh-line", text: "出现新回应时，会把节点重新排序并标注更新。" },
                ].map((row) => (
                  <li key={row.text} className="flex items-start gap-3">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                      <i className={row.icon}></i>
                    </span>
                    <span className="text-xs leading-relaxed text-foreground-700">{row.text}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-5 rounded-md border border-background-200 bg-background-100 p-3">
                <p className="text-[11px] leading-relaxed text-secondary-600">
                  页面内所有人物与事件均为演示用虚构内容，仅用于展示归档形式。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}